import { ICON_TYPES } from '../constants';

export const PlayButtonIcon = (): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M19.765 9.45707L4.97998 0.0180664V24.0181L19.759 14.5451C20.1892 14.2747 20.5438 13.8997 20.7899 13.4551C21.0359 13.0105 21.1652 12.5108 21.1658 12.0027C21.1664 11.4946 21.0383 10.9946 20.7933 10.5495C20.5483 10.1043 20.1945 9.72847 19.765 9.45707ZM18.685 12.8521L6.98498 20.3521V3.67607L18.692 11.1501C18.8363 11.2403 18.9552 11.366 19.0374 11.5151C19.1196 11.6642 19.1624 11.8318 19.1617 12.002C19.161 12.1723 19.1168 12.3395 19.0334 12.4879C18.95 12.6363 18.8301 12.761 18.685 12.8501V12.8521Z"
          fill="#141414"
        />
      </g>
    </svg>
  );
};

PlayButtonIcon.iconType = ICON_TYPES.PLAY_BUTTON;
